import {
  TSale,
  TSaleDetailsResponse,
  TSaleListItem,
  TSaleStatus,
} from "./reports.types";

export const mapStatusToTSaleStatus = (status: string): TSaleStatus => {
  if (status === "paid" || status === "approved") return TSaleStatus.approved;
  if (status === "pending") return TSaleStatus.pending;
  if (status === "failed") return TSaleStatus.failed;
  if (status === "refunded") return TSaleStatus.refunded;
  if (status === "rejected") return TSaleStatus.rejected;
  if (status === "cancelled") return TSaleStatus.cancelled;
  return TSaleStatus.pending;
};

export const mapSaleListItemToTSale = (item: TSaleListItem): TSale => ({
  id: item.sale_id,
  plan_name: item.plan_name,
  partner_name: item.partner,
  client_name: item.customer_name,
  client_cpf: item.customer_cpf,
  sale_price: item.value_sale,
  status: mapStatusToTSaleStatus(item.status),
  sale_date: new Date(item.sale_date),
  client_details: {
    email: "",
    full_name: item.customer_name,
    cellphone: "",
    birthdate: "",
    cpf: item.customer_cpf,
    gender: "",
    zip: "",
    address: "",
    number: "",
    complement: "",
    district: "",
    city: "",
    state: "",
    external_customer_id: 0,
  },
  plan_details: {
    id: "",
    name: item.plan_name,
    description: item.plan_description,
    products: [],
  },
  ...(item.product_id
    ? {
        product_id: item.product_id,
        product_name: item.product_name,
        product_value: item.product_value,
      }
    : {}),
});

export const mapSaleDetailsToSale = (data: TSaleDetailsResponse): TSale => ({
  id: data.sale_info.sale_id,
  plan_name: data.plan.plan_name,
  partner_name: data.sale_info.partner,
  client_name: data.customer.full_name,
  client_cpf: data.customer.cpf,
  sale_price: data.sale_info.total_amount,
  status: mapStatusToTSaleStatus(data.sale_info.status),
  sale_date: new Date(data.sale_info.sale_date),
  client_details: {
    email: data.customer.email,
    full_name: data.customer.full_name,
    cellphone: data.customer.cellphone,
    birthdate: data.customer.birthdate,
    cpf: data.customer.cpf,
    gender: data.customer.gender,
    zip: data.customer.address.cep,
    address: data.customer.address.street,
    number: data.customer.address.number,
    complement: data.customer.address.complement,
    district: data.customer.address.neighborhood,
    city: data.customer.address.city,
    state: data.customer.address.state,
    external_customer_id: 0,
  },
  plan_details: {
    id: data.plan.plan_id,
    name: data.plan.plan_name,
    description: data.plan.description,
    products: data.plan.products.map((p) => ({
      id: p.product_id,
      name: p.product_name,
      description: p.description,
      price: p.price,
      ...(p.insurance_company_name
        ? { insurance_company_name: p.insurance_company_name }
        : {}),
    })),
  },
});
